<template>
  <div class="navbar">
    <h2>Document requests</h2>
    <ul class="nav nav-stacked">
      <request-item-view
        v-for="request in requests"
        :key="request.id"
        :request="request"
        :active="isActive(request)"
        @activate="$emit('activate', request.id)"
      />
    </ul>
  </div>
</template>

<script>
import RequestItemView from './request-list/request.vue';
import DocumentRequestModel from '../../../models/documentRequest';

export default {
  components: {
    RequestItemView,
  },
  props: {
    requests: {
      type: Array,
      default: () => [],
    },
    activeRequest: {
      type: DocumentRequestModel,
      default: null,
    },
  },
  methods: {
    isActive(request) {
      return (!!this.activeRequest) && request.id === this.activeRequest.id;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import './resources/assets/sass/variables';

.navbar {
  height: 100%;
  .nav {
    li.active {
      background-color: $grey;
    }
  }
}
</style>
